import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { RouterLink } from '@angular/router';
import { DrawState, ProfileDrawProjection, RegistrationState } from '@unicup-ticketing/service';
import { ButtonComponent } from '@unicup-ticketing/ui';
import { DrawItemContainerComponent } from '@unicup-ticketing/core';

@Component({
  selector: 'ticketing-customer-draw-item',
  imports: [ButtonComponent, FaIconComponent, RouterLink, DrawItemContainerComponent],
  templateUrl: './customer-draw-item.component.html',
  styleUrl: './customer-draw-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerDrawItemComponent {
  draw = input.required<ProfileDrawProjection>();
  protected readonly faArrowRight = faArrowRight;
  protected readonly DrawState = DrawState;
  protected readonly RegistrationState = RegistrationState;
}
